import React, { InputHTMLAttributes, ReactElement } from "react";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  value: string;
  isChecked: boolean;
  children?: React.ReactNode;
  onChange: () => void;
}

export function AppRadio(props: Props): ReactElement {
  return (
    <div className="AppRadioWrapper">
      <input type="radio" value={props.value} onChange={props.onChange} checked={props.isChecked} />
      <label>{props.value}</label>
    </div>
  );
}
